var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{staticClass:"approval-response"},[_c('i',{staticClass:"mtdicon mtdicon-error-circle-thick-o"}),_vm._v(" "),_c('span',[_vm._v("驳回原因：")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.reason))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }